module.exports = function (app) {
    var attachFileAlertModal = require("chmhom/modals/attachFileAlertModal");
    app.controller('pages.account.tobacco-information', ['$scope','session','services','brand','modal','sessionData',
        function ($scope,session,services,brand,modal,sessionData) {
            $scope.heading = "Tobacco Information";
            var btsGlobal = {config: {brand: brand.current}, appConfig: sessionData.appConfig};
            if (btsGlobal.config.brand.umsBrandCode) {
                var brand = btsGlobal.config.brand.umsBrandCode;
            }
            else {
                var brand = btsGlobal.config.brand.sharedBrandCode;
            }
            $scope.offExchange=false;
            $scope.isDependent=null;
            var saveSuccess = false;
            $scope.updateRequired=false;

            var getAge = function (dob) {
                var today = new Date();
                var birthday = new Date(dob);
                var age;

                today.setHours(0);
                today.setMinutes(0);
                today.setSeconds(0);
                today.setMilliseconds(0);

                age = ((today - birthday) / (1000 * 60 * 60 * 24 * 365));

                return age;
            };
            var pastDate = new Date();
            pastDate.setMonth(pastDate.getMonth()-6);
            $scope.pastDate = pastDate;
            $scope.today =new Date();

            var tobaccoParse= function(response) {
                var tobaccoPayload = response.data.payload.tobaccoInfo;
                $scope.tobaccoPayload = tobaccoPayload;
                var tList = tobaccoPayload.tobaccoList;
                var mbrArr = [];

                // iterate over the tobacco list
                for (var i = 0; i < tList.length; i++) {
                    var tobaccoUser = "";
                    var firstName = "";
                    var lastName = "";
                    var mbrUpdateRequired = false;
                    var modulo = true;
                    var statusKnown = false;
                    var updateRequired = false;
                    var showDOB = false;
                    var drawerOpen = false;
                    var lastReportDate = '';
                    var age = getAge(tList[i].member.birthDate);
                    var onExchangeLink = "";


                    var isIBC = brand === 'ibccr' || brand === 'ibcah';
                    if (isIBC && age < 21)
                        continue;
                    else if((age < 18 || !effectuated) && !isIBC) //FIXME
                        continue;

                    // style each drawer's colors/banding
                    if (i % 2 > 0) {
                        modulo = false;
                    }
                    //submit
                    if(brand== 'ibccr' || brand == 'ibcah'){
                        onExchangeLink = '/chmptl/chm/jsp/categorydetail.do?oid=-21884&parentId=-13548&type=channel';
                    }else if(brand== 'hmbcbs' || brand == 'hbs' || brand == 'hmbcbsde'){
                        onExchangeLink = '/chmptl/chm/jsp/categorydetail.do?oid=-21889&parentId=-13548&type=channel';
                    }else if(brand == 'mincr'){
                        onExchangeLink = 'https://www.bluecrossmn.com/quittobacco';
                    }else{
                        onExchangeLink = '/chmptl/chm/jsp/categorydetail.do?oid=-21888&parentId=-13548&type=channel';
                    }

                    // interpret tobaccoIncidator values
                    if (tList[i].tobaccoIndicator.toUpperCase() === "T") {
                        tobaccoUser = "true";
                        statusKnown = true;
                    }
                    else if (tList[i].tobaccoIndicator.toUpperCase() === "N") {
                        tobaccoUser = "false";
                        statusKnown = true;
                    }
                    else if (tList[i].tobaccoIndicator.toUpperCase() === "U" || tList[i].tobaccoIndicator === "") {
                        mbrUpdateRequired = true;
                        $scope.updateRequired = true;
                    }

                    // set last usage date if present, otherwise empty string
                    if (tList[i].tobaccoUseLastReportDate && tList[i].tobaccoUseLastReportDate != "") {
                        lastReportDate = tList[i].tobaccoUseLastReportDate;
                    }

                    // load up your member object with the properties from the list

                    var mbr = {
                        "relationship": tList[i].member.relationship,
                        "firstName": tList[i].member.firstName.toLowerCase(),
                        "lastName": tList[i].member.lastName.toLowerCase(),
                        "dob": tList[i].member.birthDate,
                        "originalTobaccoIndicator": tList[i].tobaccoIndicator,
                        "originalTobaccoUseLastReportDate": lastReportDate,
                        "newTobaccoIndicator": "",
                        "lastUsageDate": {value: new Date(lastReportDate)},
                        "isTobaccoUser": {value: tobaccoUser},
                        "isTheSub": (i == '0')? true : false,
                        "showDOB": showDOB,
                        "lastUser": false,
                        "drawerOpen": drawerOpen,
                        "modulo": modulo,
                        "onExchangeLink": onExchangeLink,
                        submission: {
                            msg: "Failure message!",
                            status: false
                        },
                        "updateRequired": mbrUpdateRequired,
                        "statusKnown": statusKnown
                    };
                    // Push the obj onto the mbrArr
                    mbrArr.push(mbr);
                }
                // Open the top drawer
                mbrArr[0].drawerOpen = "open";

                // Plug your array of member objects into the model
                $scope.members = mbrArr;
                $scope.userArr = getUsers("T");
                // create array of undeclared users
                $scope.undeclaredArr = getUsers("U");
                setAccountStatus();
                formatNames();
            };

            var preRender = function () {
                var serviceCalls = [];
                var accountHasUsers = [];
                var tobaccoFree = false;
                var memberInfo = session.data.memberInfo;
                var selectedPlan = services.rbsmbl.memberInfo().getPortalSelectedPlan(session.data.memberInfo);

                var selectedProduct = null;
                for (var i = 0; i < selectedPlan.productList.length; i++) {
                    if (selectedPlan.productList[i].benefitPlanType && selectedPlan.productList[i].benefitPlanType.toUpperCase() === 'MEDICAL') {
                        selectedProduct = selectedPlan.productList[i];
                        break;
                    }
                }
                if (!selectedProduct) {
                    selectedProduct = selectedPlan.productList[0];
                }

                var effectuatedDate = selectedProduct.effectuatedDate;
                if (effectuatedDate)
                    effectuated = true;
                else
                    effectuated = false;
                if (selectedProduct.hcrProduct && selectedProduct.hcrProduct.toUpperCase() === "ON") {
                    $scope.offExchange = false;
                }
                else if (selectedProduct.hcrProduct && selectedProduct.hcrProduct.toUpperCase() === "OFF") {
                    $scope.offExchange = true;
                }
                $scope.isDependent = (selectedProduct.memberList[0].relationship != 'Subscriber' ? true : false);
                //check here for relationship status. subscriber only will use getTobaccoFamilyInfo, the rest use getTobaccoInfo
                var relationship = selectedProduct.memberList[0].relationship;
                if (relationship.toUpperCase() === "SUBSCRIBER") {
                    services.rbsmbl.tobaccoRetrieve().getTobaccoFamilyInfo(memberInfo.clientList[0].clientNumber,selectedPlan.groupNumber).then(function(response){
                        tobaccoParse(response);
                    })
                }
                else {
                    services.rbsmbl.tobaccoRetrieve().getTobaccoInfo(memberInfo.clientList[0].clientNumber,selectedPlan.groupNumber).then(function (response2) {
                        tobaccoParse(response2);
                    });

                }


            };
            var getUsers=function(type) {
                var userArr = [];
                //step through tobacco payload and make an array of names of users, filtering them by type (users, non, and unreported)
                for (var i = 0; i < $scope.members.length; i++) {
                    if ($scope.members[i].originalTobaccoIndicator === type) {
                        userArr.push($scope.members[i]);
                    }
                    else if (type === "U" && $scope.members[i].originalTobaccoIndicator === "") {
                        userArr.push($scope.members[i]);
                    }
                }
                return userArr;
            };
            var setAccountStatus= function() {
                if ($scope.userArr && $scope.userArr.length > 0) {
                    $scope.tobaccoFree = true;
                }
            };

            var formatNames= function() {
                for (var i = 0; i < $scope.members.length; i++) {
                    var tmp = $scope.members[i];
                    for (var j = i + 1; j < $scope.members.length; j++) {
                        if (tmp.firstName === $scope.members[j].firstName
                            && tmp.lastName === $scope.members[j].lastName) {
                            tmp.showDOB = true;
                            $scope.members[j].showDOB = true;
                        }
                    }
                }
            };

            $scope.memberClicked= function (mem){
                if(mem.drawerHeight > 0 || mem.drawerOpen == "open"){
                    mem.drawerHeight = 0;
                    mem.drawerOpen = " ";
                } else {
                    //figure height... // height id different for 1 vs >1 in length
                    //var groupCount = mem.groups.length;
                    //var groupHeight = 292 * groupCount;
                    //add height - for more than 2+ plans (multiply)
                    // mem.drawerHeight = groupHeight;
                    mem.drawerOpen = "open";
                }
            };

            var changesExist=function() {
                this.members = $scope.members;
                var hasChanges = false;
                for (var i = 0; i < this.members.length; i++) {
                    if (formatDate(this.members[i].originalTobaccoUseLastReportDate) != formatDate(this.members[i].lastUsageDate.value)) {
                        hasChanges = true;
                    }
                    if (this.members[i].isTobaccoUser.value == "true") {
                        if (this.members[i].originalTobaccoIndicator != "T") {
                            hasChanges = true;
                        }
                    }else if(this.members[i].isTobaccoUser.value == 'false'){
                        if(this.members[i].originalTobaccoIndicator != 'N'){
                            hasChanges = true;
                        }
                    }
                    else {
                        if (this.members[i].originalTobaccoIndicator == "T") {
                            hasChanges = true;
                        }
                    }
                }
                return hasChanges;
            }

            $scope.checkForChanges= function(member) {

                try{
                    //needed for IE8 radio button
                    var target = event.target;
                    member.isTobaccoUser.value = target.value;
                }catch(e){
                    //no target
                }

                $scope.saveSuccess = false;
                if (changesExist()) {
                    $scope.disableButtons = false;
                    $scope.showButtons = true;
                }
                else {
                    $scope.disableButtons = true;
                    $scope.showButtons = false;
                }
            };


            $scope.cancel= function() {
                // Add cancel input function here
                for (var i = 0; i < $scope.members.length; i++) {
                    $scope.members[i].lastUsageDate.value = $scope.members[i].originalTobaccoUseLastReportDate;
                    if ($scope.members[i].originalTobaccoIndicator.toUpperCase() === "U" || $scope.members[i].originalTobaccoIndicator === "") {
                        $scope.members[i].isTobaccoUser.value = "";
                    }
                    else if ($scope.members[i].originalTobaccoIndicator.toUpperCase() === "T") {
                        $scope.members[i].isTobaccoUser.value = "true";
                    }
                    else if ($scope.members[i].originalTobaccoIndicator.toUpperCase() === "N") {
                        $scope.members[i].isTobaccoUser.value = "false";
                    }
                    $scope.members[i].lastUsageDate.$validate();
                }
            };

            var createPostData= function() {
                this.members=$scope.members;
                var tobaccoList = [];
                for (var i = 0; i < this.members.length; i++) {
                    if ($scope.isUser(this.members[i]) && this.members[i].lastUsageDate.value
                        && this.members[i].lastUsageDate.value != "") {
                        var date = formatDate(this.members[i].lastUsageDate.value);
                    }
                    else {
                        date = "";
                    }
                    var tmp = {
                        "member": {
                            "coveredIndividualId": $scope.tobaccoPayload.tobaccoList[i].member.coveredIndividualId
                        },
                        "tobaccoIndicator": getIndicatorValues(this.members[i].isTobaccoUser.value),
                        "tobaccoUseLastReportDate": date
                    };
                    tobaccoList.push(tmp);
                }
                var postData = {
                    "tobaccoInfo": {
                        "clientId": $scope.tobaccoPayload.clientId,
                        "groupId": $scope.tobaccoPayload.groupId,
                        "internalGroupId": $scope.tobaccoPayload.internalGroupId,
                        "tobaccoList": tobaccoList
                    }
                };
                return postData;
            }
            $scope.save= function(postData) {
                // Add save function here
                // @TODO define the two data loads

                // divide between dep and sub
                // sub will cycle through all members and check for smoker status
                // if yes, validDate will run
                // if validDate passes
                // run createPostData + save

                var that = this;
                var isValid = true;
                var memberError = [];
                this.members = $scope.members;
                for (var i = 0; i < this.members.length; i++) {
                    if (!this.members[i].lastUsageDate) {
                        isValid = false;

                        //opens drawer of member with error and adds to array of members with errors
                        this.members[i].drawerOpen = 'open';
                        memberError.push(this.members[i]);
                    }
                }

                // FIXME: refactor this out once bootstrap supports scrolling to failed validation nodes
                // FIXME: refactor this out once bootstrap supports scrolling to failed validation nodes
                //focuses on first member with error
                if(memberError.length > 0){
                    var memberId = this.members[0].firstName + this.members[0].dob;
                    document.getElementById(memberId).scrollIntoView();
                }
                if (!isValid) {
                    return;
                }
                // FIXME: refactor this out once bootstrap supports scrolling to failed validation nodes
                // FIXME: refactor this out once bootstrap supports scrolling to failed validation nodes

                postData = createPostData();
                var currentMember = services.rbsmbl.memberInfo().currentMember(session.data.memberInfo);

                // @TODO Add Parameters
                if(currentMember.relationship.toUpperCase() == 'SUBSCRIBER'){
                    var saveData = services.rbsmbl.tobaccoSave().saveData(postData);
                }else{
                    var saveData = services.rbsmbl.tobaccoSave().saveDataDep(postData);
                }
                $scope.disableButtons = true;

                // TODO: Check to make sure that this nonsense is for real. saveData doesn't exist.
                saveData.then(function(data) {
                    var failedArray = [];
                    for (var i = 0; i < $scope.members.length; i++) {
                        $scope.members[i].originalTobaccoUseLastReportDate = $scope.members[i].lastUsageDate.value;
                        if ($scope.members[i].isTobaccoUser.value == "true") {
                            $scope.members[i].originalTobaccoIndicator = "T";
                        }
                        else {
                            $scope.members[i].originalTobaccoIndicator = "N";
                        }
                        if(data.data.payload.tobaccoInfo.tobaccoList[i].isTobaccoUpdateSuccess == false &&
                            data.data.payload.tobaccoInfo.tobaccoList[i].tobaccoIndicator != 'U' &&
                            data.data.payload.tobaccoInfo.tobaccoList[i].tobaccoUpdateFailureDesc != 'NO-CHANGE'){
                            failedArray.push($scope.members[i]);
                        }
                    }

                    if(failedArray.length == 0){

                        $scope.saveSuccess = true;
                    }else{
                        var nameContent = '';
                        for(var z = 0; z < failedArray.length; z++){
                            var firstName = failedArray[z].firstName.charAt(0).toUpperCase() + failedArray[z].firstName.substring(1,failedArray[z].firstName.length);
                            var lastName = failedArray[z].lastName.charAt(0).toUpperCase() + failedArray[z].lastName.substring(1,failedArray[z].lastName.length);
                            var name = firstName + ' ' + lastName;
                            nameContent += '<li><span>' + name + '</span></li>';
                        }
                        var modalDesc = "<span>We were not able to save changes for:</span></br><ul>" + nameContent + "</ul></br><span>Please check the information for these members and try again.</span>";
                        openAttachmentAlertModal('Error',modalDesc);

                       // new Modal('<span>We were not able to save changes for:</span></br><ul>' + nameContent + '</ul></br><span>Please check the information for these members and try again.<button data-click="closeModal()" class="action-btn">OK</button></p>', {heading: 'Error'});
                    }
                    $scope.disableButtons = false;
                    $scope.$apply();
                }, function(error) {
                    //new Modal(teamsiteContent.MER_IDCARD_TROUBLE_PROCESSING, {heading: 'Error'});
                    var modalDesc = "<span data-aem-content='MER_IDCARD_TROUBLE_PROCESSING'></span>";
                    openAttachmentAlertModal('Error',modalDesc);
                    $scope.disableButtons = false;
                    $scope.$apply();
                });

                if($scope.tobaccoSaveCoremetrics != true)
                {
                    //btsGlobal.coremetrics.elementTag('Save','MEMBER:ACCOUNT SETTINGS');
                    $scope.tobaccoSaveCoremetrics = true;
                }
                return $scope.saveSuccess;
            };

            var getIndicatorValues=function(val) {
                // interpret tobaccoIncidator values
                switch (val) {
                    case "T":
                        return true;
                    case "N":
                        return false;
                    case "U":
                        return "U";
                    case "true":
                        return "T";
                    case "false":
                        return "N";
                }
            };

            var dateValidate= function(member) {
                if (member.isTobaccoUser.value === "true") {
                    var tMonths = (new Date()).getFullYear() * 12;
                    tMonths = tMonths + (new Date()).getUTCMonth() + 1;
                    var tDate = (new Date()).getUTCDate();

                    var eMonths = (new Date(formatDate(member.lastUsageDate.value))).getFullYear() * 12;
                    eMonths = eMonths + (new Date(formatDate(member.lastUsageDate.value))).getUTCMonth() + 1;
                    var eDate = (new Date(formatDate(member.lastUsageDate.value))).getUTCDate();

                    if ((!eDate) || (!eMonths)) {
                        return "Please enter a valid date";
                    }

                    if (eMonths > tMonths) {
                        return "Date cannot be in the future";
                    }
                    else if (eMonths === tMonths) {
                        if (eDate > tDate) {
                            return "Date cannot be in the future";
                        }
                    }
                    else if (eMonths === tMonths - 6) {
                        if (eDate <= tDate) {
                            return "Date cannot be more than 6 months in the past";
                        }
                    }
                    else if (eMonths < tMonths - 6) {
                        return "Date cannot be more than 6 months in the past";
                    }
                }
            };

            $scope.isUser= function(member) {
                if (member.isTobaccoUser.value === "true") {
                    return true;
                }
                else if (member.isTobaccoUser.value === "false") {
                    return false;
                }
            };
            var formatDate=function(dateStr) {
                //TODO: This function should be revisited. Format the dates correctly
                // create new date object in this fashion to avoid off by one pitfall of new Date constructor
                var newDate = new Date(dateStr);
                var m = newDate.getUTCMonth()+1;
                var d = newDate.getUTCDate();
                var y = newDate.getFullYear();

                // account for required leading zeros
                var dd = ('0' + d).slice(-2);
                var mm = ('0' + m).slice(-2);
                var yyyy = newDate.getFullYear();
                if(dd == '01' && mm == '01'){
                    yyyy = yyyy + 1;
                }


                dateStr = mm + "/" + dd + "/" + yyyy;
                return dateStr;
            };
            var openAttachmentAlertModal =function(title,description,buttons){
                $scope.modalTitle = title;
                $scope.modalDescription = description;
                if(buttons){
                    $scope.modalButtons =buttons;
                }else {
                    $scope.modalButtons = [
                        {
                            buttonLabel: "OK",
                            buttonClass: "primary",
                            buttonAction: function () {
                                $scope.closeModal()
                            }
                        }
                    ];
                }
                modal.open({
                    template: require('chmhom/modals/attachFileAlertModal.html'),
                    controller: attachFileAlertModal,
                    scope: $scope
                });
            };

            $scope.hcrLinkCoremetrics= function(){
                btsGlobal.coremetrics.elementTag('Make Changes to your coverage','MEMBER:ACCOUNT SETTINGS');
            };
            $scope.isSubscriber= function(member){
                return member.isTheSub;
            }

            preRender();


        }
    ]);


}